/**
 * Returns key count/length
 */
export const objectLength = (obj: object) => Object.keys(obj).length;
